import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrl, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from './../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, showSuccessMessage };

export const GET_PROMPT_CODES_LIST_API = `${API_URL}/api/MasterPromptCodes/GetMasterPromptCodes`;
export const POST_PROMPT_CODES_API = `${API_URL}/api/MasterPromptCodes/SaveMasterPromptCode`;
export const GET_PROMPT_CODES_DETAIL_API = `${API_URL}/api/MasterPromptCodes/GetMasterPromptCodeById`;
export const DELETE_PROMPT_CODES_API = `${API_URL}/api/MasterPromptCodes/DeleteMasterPromptCode`;

export const propmtCodesActionTypes = {
  save_propmtCodes: createRequestActionTypes('SAVE_PROMPT_CODES'),
  get_propmtCodesList: createRequestActionTypes('GET_PROMPT_CODESLIST'),
  get_propmtCodesDetail: createRequestActionTypes('GET_PROMPT_CODESDETAIL'),
  delete_propmtCodes: createRequestActionTypes('DELETE_PROMPT_CODES'),
};

export const MODULE = 'DCMASTER_PROMPTCODES';


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/promptCodes/constants/ApiConstants.js